module.exports = __webpack_public_path__ + "img/icon-delete-light-blue.e24f7a02.svg";